export const locales = {
    'en-us': {
        first_page: 'First',
        last_page: 'Last',
        previous_page: 'Previous page',
        next_page: 'Next page',
    },
    'es-us': {
        first_page: 'First',
        last_page: 'Last',
        previous_page: 'Previous page',
        next_page: 'Next page',
    },
};
//# sourceMappingURL=locales.js.map